
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/dummy',[
      "Vue",
      "helpers",
      "vuex",
      'vue!./ageRestrictionComponent',
      "vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/GroupMembersOtb"
  ], function (
      Vue,
      helpers,
      vuex,
      ageRestrictionComponent,
      GroupMembersOtb
  ) {
      return {
          template: template,
          name: "",
          props: ['customerID', 'service', 'selected', 'isAgeValid', 'isAgeRestrictActive'],
          data: function () {
              return {
                  message: ''
              }
          },
          computed: _.extend(
              vuex.mapState(['activeService', 'users', 'guestProfiles', 'ageRestrictionErrMessages', 'OTBactive', 'loggedInUser', 'status']), {

                  requireDatePicker: function () {
                     
                      if (this.service.SpaItemId == this.activeService) {
                          requireDatepicker = false

                          if (_.keys(this.users).length > 1) {
                              requireDatepicker = this.guestProfiles[this.customerID].requireDatePicker
                          } else {
                              var c = this.verifyAge(this.service)
                              if (!app.data.userLoggedIn) {
                                  !c.isValid ? this.$store.commit('setAgeRestrictionErrMessages', {
                                      id: this.customerID,
                                      message: app.localization.spaBooking.packageBooking.ageRestriction.ageRestrictionMessage
                                  }) : ''
                                  return;
                              }
                              requireDatepicker = c.requireDatePicker
                          }
                          //If user is required to enter then date of birth, but is not allowed to edit, then return error message to user --Start
                          if (!_.isEmpty(this.guestProfiles) && this.guestProfiles[this.customerID].CanEdit == "N" && requireDatepicker) return false;
                          //If user is required to enter then date of birth, but is not allowed to edit, then return error message to user --End

                          return requireDatepicker || this.guestProfiles[this.customerID] && this.guestProfiles[this.customerID]['addedByDatePicker']
                      }
                  }
              }),
          components: {
              ageRestrictionComponent: ageRestrictionComponent,
              'grp-member-otb':GroupMembersOtb
          },
          methods: {

          },
      }
  })
})('<div class="ageDiv" v-if="selected || Object.keys(users).length == 1"> <p class="spa-service-age-restriction-messages"> {{ageRestrictionErrMessages[customerID]}}</p> <div v-if="requireDatePicker"> <age-restriction-component v-bind:customerID="customerID" v-bind:service="service"></age-restriction-component> </div> <grp-member-otb v-if="(isAgeRestrictActive && !isAgeValid) && loggedInUser && OTBactive && customization.allowSpaGuestRequest && (status != \'E\')" :service="service" :isAgeValid="isAgeValid"></grp-member-otb> </div>');
